// extracted by mini-css-extract-plugin
export default {"newsCard":"newsCard_newsCard__xHkq9","newsImage":"newsCard_newsImage__VSXhP","newsInfo":"newsCard_newsInfo__DSBGZ","newsButton":"newsCard_newsButton__pUB+7"};